export const DeleteRedIcon = ({
  fill = "#E02424",
  width = "20px",
  height = "20px",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.08975 17.0841C5.67415 17.0841 5.31919 16.937 5.02485 16.6426C4.73051 16.3483 4.58333 15.9933 4.58333 15.5777V5.00082H4.375C4.19765 5.00082 4.04915 4.94099 3.9295 4.82134C3.80983 4.70169 3.75 4.55319 3.75 4.37584C3.75 4.19849 3.80983 4.04999 3.9295 3.93034C4.04915 3.81067 4.19765 3.75084 4.375 3.75084H7.49998C7.49998 3.54678 7.57183 3.37291 7.71552 3.22921C7.85922 3.08552 8.03309 3.01367 8.23715 3.01367H11.7628C11.9669 3.01367 12.1407 3.08552 12.2844 3.22921C12.4281 3.37291 12.5 3.54678 12.5 3.75084H15.625C15.8023 3.75084 15.9508 3.81067 16.0705 3.93034C16.1901 4.04999 16.25 4.19849 16.25 4.37584C16.25 4.55319 16.1901 4.70169 16.0705 4.82134C15.9508 4.94099 15.8023 5.00082 15.625 5.00082H15.4166V15.5777C15.4166 15.9933 15.2695 16.3483 14.9751 16.6426C14.6808 16.937 14.3258 17.0841 13.9102 17.0841H6.08975ZM14.1666 5.00082H5.83331V15.5777C5.83331 15.6525 5.85735 15.7139 5.90544 15.762C5.95352 15.8101 6.01496 15.8342 6.08975 15.8342H13.9102C13.985 15.8342 14.0464 15.8101 14.0945 15.762C14.1426 15.7139 14.1666 15.6525 14.1666 15.5777V5.00082ZM7.83654 14.1675H9.08652V6.66748H7.83654V14.1675ZM10.9134 14.1675H12.1634V6.66748H10.9134V14.1675Z"
        fill={fill}
      />
    </svg>
  );
};
